/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';

import { TYPES } from './constants';

const Item = ({ className, module, previewImg, errors }) => {
  const type = TYPES.find(({ value }) => value === module.type);

  return (
    <InfoItem.WithError
      error={errors}
      className={className}
      size="large"
      image={previewImg}
      description={type?.label || 'Type not found'}
    >
      Stats
    </InfoItem.WithError>
  );
};

export default Item;
